import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import DescriptionSection from '@/components/DescriptionSection';
import ReviewsSection from '@/components/ReviewsSection';
import FAQSection from '@/components/FAQSection';
import Footer from '@/components/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';
import { trackViewContent, PRODUCT_DATA } from '@/lib/metaPixel';

const Notes: React.FC = () => {
  useEffect(() => {
    // Meta Pixel - ViewContent for Notes page
    trackViewContent({
      content_name: 'Notes Page - Class 10 Science',
      content_category: 'Study Notes',
      content_ids: PRODUCT_DATA.content_ids,
      content_type: PRODUCT_DATA.content_type,
      value: PRODUCT_DATA.value,
      currency: PRODUCT_DATA.currency,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Class 10 Science Notes - Toppers Short Notes for CBSE Board 2025-2026</title>
        <meta name="description" content="Get the best class 10 science notes for CBSE board exams. Toppers short notes with Physics, Chemistry, Biology - diagrams, formulas, key concepts. Only ₹149." />
        <meta name="keywords" content="class 10 science notes, class 10th notes, science notes class 10, CBSE notes class 10, physics notes class 10, chemistry notes class 10, biology notes class 10, board exam notes" />
        <link rel="canonical" href="https://toppersbuddy.lovable.app/notes" />
        <meta property="og:title" content="Class 10 Science Notes - Toppers Short Notes for CBSE Board" />
        <meta property="og:url" content="https://toppersbuddy.lovable.app/notes" />
      </Helmet>

      <div className="flex min-h-screen flex-col bg-background">
        <Header />
        <main role="main" aria-label="Class 10 Science Notes" className="flex-1">
          <HeroSection />
          <DescriptionSection />
          <ReviewsSection />
          <FAQSection />
        </main>
        <Footer />
      </div>
      
      <WhatsAppButton />
    </>
  );
};

export default Notes;
